// Port of api/fuel/app/classes/filter/search/games/rules/query/has_commented.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'has_commented',
	match: function(rule, config, filter, data, query) {
		if (rule.logic.value === 'yes') {
			query.exist('comment', 'm')
		} else if (rule.logic.value === 'no') {
			query.notexist('comment', 'mn')
		}
	}
})
